const en = {

  // Content Management
  nameRequired: "Full Name is required.",
  subjectRequired: "Subject is required",
  famePhotoRequired: "The Image field is required",
  contentRequired: "Content is required",
  designationRequired: "Designation is required",
  imageRequired: "The Image field is required",
  readMoreRequired: "Read more link is required",
  topicNameRequired: "Topic name is required",

  // Event Createion
  categoryRequired: "Event category is required",
  fromDateRequired: "From date is required",
  toDateRequired: "To date is required",
  fromTimeRequired: "From time is required",
  toTimeRequired: "To time is required",
  venueRequired: "Venue is required",
  descriptionRequired: "Description is required",

  //PASSWORD
  oldPasswordRequired: "Old password is required.",
  passworLeastCharacterdRequired: "Password must be at least 6 characters.",
  newPasswordRequired: "New password is required.",
  newPasswordifferentCharacterdRequired: "New password must be different from old password",
  confirmPassword: "Please confirm your new password",
  doNotMatchPassowrd: "Passwords do not match",






  // Create Day Schedule
  // Common
  required: "is required",

  // Fields
  classLabel: "Class",
  sectionLabel: "Section",
  dayLabel: "Day",
  shiftLabel: "Shift",
  period: "Period",
  periodSubject: "Subject",

  // Placeholders (optional)
  classPlaceholder: "Select Class",
  sectionPlaceholder: "Select Section",
  dayPlaceholder: "Select Day",
  shiftPlaceholder: "Select Shift",
  periodSubjectPlaceholder: "Select Subject",

  // Error messages
  invalidPeriodCount: "Number of Periods must be between 1 and 20",


  // syllabus
  classRequired: "Class is required",
  chapterRequired: "Chapter is required",
  unitRequired: "Units is required",
  examTypeRequired: "Exam type is required",

  shortDescriptionRequired: "Short description is required",
  pageFromRequired: "Page from is required",
  pageToRequired: "Page to is required",
  sectionRequired: "Section is required",
  shiftRequired: "Shift is required",
  subjectRequired: "Subject is required",

  // Mark entry
  dateOfExamRequired: "Date of exam is required",
  examNameRequired: "Exam name is required",
  modeOfNameRequired: "Mode of exam is required",

  //COMMON
  firstNameRequired: "First Name is required.",
  lastNameRequired: "Last Name is required.",
  emailRequired: "Email is required.",
  phoneRequired: "Phone Number is required.",
  genderRequired: "Gender is required.",
  dobRequired: "Date of Birth is required.",
  firstNamelength: "First name must be at least 3 characters.",

  experienceRequired: "Experience is required.",
  suggestionRequired: "Suggestion is required.",
  onlyAlphabetsAllowed: "Only alphabets and spaces are allowed.",

  //PROFILE
  pincodeRequired: "Valid 6-digit Pincode is required.",
  stateRequired: "State is required.",
  districtRequired: "District is required.",
  cityRequired: "City/Town/Village is required.",
  addressRequired: "Address is required.",
  religionRequired: "Religion is required.",
  templeFrequencyRequired: "Temple Visit Frequency is required.",
  languageRequired: "Language is required.",
  phoneTenDigits: "The phone number must be 10 digits.",
  phonestarts: "Number cannot start from 0.",
  aadharInvalid: "Aadhar number must be a 12-digit number.",
  passportInvalid:
    "Passport number must be 1 letter followed by 7 digits (e.g., K1234567).",
  firstNameInvalid: "First name must only contain letters and spaces.",
  lastNameInvalid: "Last name must only contain letters and spaces.",



  //IMAGE
  fileTooLarge: "File size must not exceed 2MB.",
  invalidFileType: "Invalid file type. Please upload a JPG/JPEG or PNG image.",
  imageUploadFailed: "Image upload failed. Please try again.",
};

export default en;
